<template>
  <div id="home">
    <!--  BARRA SUPERIOR -->
    <!--TopPanel
      :activeTab="activeTab"
      @update:activeTab="activeTab = $event"
      @year-changed="onYearChanged"
    /-->
    <TopPanel
      :tabs="[
        { label: 'Caracterización', path: '/caracterizacion/' },
        { label: 'Rating', path: '/rating/' },
        { label: 'Materia prima', path: '/materiaprima/' }
      ]"
      @year-changed="onYearChanged"
    />

    <!-- 🔹 CUERPO PRINCIPAL (vacío hasta que usuario seleccione algo) -->
    <div id="body" class="mt-4">
      <v-row>
        <v-col cols="12">
          <v-card flat class="rounded" style="height: 80vh;">
            <v-row>
              <v-col>
                
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import YearPicker from '@/components/YearPicker.vue';
import TopPanel from "@/components/layout/TopPanel.vue";


export default {
  name: 'Home',
  components: {YearPicker, TopPanel},
  data() {
    return {
      activeTab: -1,
      user_id: localStorage.getItem('user_id'), // Recupera el user_id del localStorage
      user_role: localStorage.getItem('user_role'), // Recupera el user_id del localStorage
      tabs: [
        { label: 'Caracterización', path: '/caracterizacion/' },
        { label: 'Rating', path: '/rating/' },
        { label: 'Materia prima', path: '/materiaprima/' },
      ],
   
    }
  },
  computed:{
    ...mapState(['selectedProducer', 'generalData', 'selectedYear']),
    ...mapGetters(['availableYears']),
  },
  methods: {
    navigateTo(index) {
      this.activeTab = index;
      this.$router.push({ path: this.tabs[index].path });
    },
    onYearChanged(newYear) {
      console.log("📅 Cambio de año detectado en Home.vue:", newYear);

      // 🔹 Actualiza año en Vuex
      this.$store.commit("setSelectedYear", newYear);

      // 🔹 Rehidrata productores del año
      this.$store.dispatch("hydrateProducersByYear", newYear);

      // 🔹 Limpia productor seleccionado
      //this.$store.commit("setSelectedProducer", null);
    },
  },
  mounted() {
    console.log("🏡 Home.vue montado. Año permitido:", this.availableYears);

    // 🔒 Si el año actual NO está permitido → corregirlo al primer año válido
    if (!this.availableYears.includes(this.selectedYear)) {
      const safeYear = this.availableYears[0];
      console.warn("⚠️ Año no permitido, ajustando a:", safeYear);
      this.$store.commit("setSelectedYear", safeYear);
      this.$store.dispatch("hydrateProducersByYear", safeYear);
    }

    // Si ya venía seleccionado un productor (admin)
    if (this.selectedProducer) {
      this.$store.dispatch('fetchGeneralData', this.selectedProducer);
    }
  }
}
</script>

<style scoped>

.v-btn.white--text {
  background-color: white;
  color: black !important;
}
.home{
  background-color: #D5D8DC;
}
/* --- Header --- */
.header-bar {
  display: flex;
  align-items: center;
}

.header-bar h2 {
  margin: 0;
  padding: 0;
  line-height: 40px;
  font-size: clamp(16px, 1.2vw, 22px);
}
</style>